define('app/directives/actions_view',['angular', 'app/services/shared'], function (angular) {
  var module = angular.module('app.actions.view', ['app.shared'])

	module.directive('bitArrayList', function() {
	  return {
		scope: {
		  bitArrayList: '=',
		  value: '@'
		},
		link: function(scope, elem, attrs ) {
		  var handler = function(setup) {
			//console.log (scope.bitArrayList);
			var ba = (scope.bitArrayList === null || angular.isUndefined(scope.bitArrayList)) ? new BitArray(1024) : BitArray.Parse64(scope.bitArrayList, true);
			var checked = ba.isBitAUno(scope.value);
			if (setup){
			  //console.log ('get ' + scope.value + ' = ' + checked)
			  elem.prop('checked', checked);
			} else {
			  ba.setBit(scope.value, !checked)
			  scope.bitArrayList = ba.Encode64();
			}
		  };
		  
		  var setupHandler = handler.bind(null, true);
		  var changeHandler = handler.bind(null, false);
				
		  elem.on('change', function() {
			scope.$apply(changeHandler);
		  });
		  scope.$watch('bitArrayList', setupHandler, true);
		}
	  };
	});

	module.directive('bitMask', function() {
	  return {
		scope: {
		  bitMask: '=',
		  value: '@'
		},
		link: function(scope, elem, attrs ) {
		  var handler = function(setup) {
			if (setup){
			  var checked = scope.bitMask&scope.value;
			  //console.log ('get ' + scope.value + '(val) & ' + scope.bitMask + '(mask) = ' + !!checked)
			  elem.prop('checked', !!checked);
			} else {
			  if (scope.bitMask&scope.value)
				  scope.bitMask ^= scope.value
			  else
				  scope.bitMask |= scope.value
			  if (scope.bitMask == 0)
				  scope.bitMask = null;
			}
		  };
		  
		  var setupHandler = handler.bind(null, true);
		  var changeHandler = handler.bind(null, false);
				
		  elem.on('change', function() {
			scope.$apply(changeHandler);
		  });
		  scope.$watch('bitMask', setupHandler, true);
		}
	  };
	});

  module.directive('decimalPlaces',function(){
    return {
      link:function(scope,ele,attrs){
        ele.bind('keypress',function(e){
          var newVal=$(this).val()+(e.charCode!==0?String.fromCharCode(e.charCode):'');
          if($(this).val().search(/(.*)\.[0-9][0-9]/)===0 && newVal.length>$(this).val().length){
            e.preventDefault();
          }
        });
      }
    };
  });
  
  module.directive('emptyToNull', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        ctrl.$parsers.push(function(viewValue) {
          if(viewValue === "") {
            return null;
          }
          return viewValue;
        });
      }
    };
  });

  module.directive('ocActionsrightView', ['$filter', function ($filter) {
    return {
      restrict: 'E',
      templateUrl: 'templates/directives/actionsright_view.html',
      scope: {
        actions: '=', // need two way (desactivem aqui)
        filter: '=',
        id: '@' // @ one-way (controler => directive), '=' two-way,
      },
      link: {
        pre: function preLink (scope, iElement, iAttrs, controller) {
          scope.isActive = function (act) {
            if (act.enablePolicy === 'allways') {
              return act.active //true
            } else if (act.enablePolicy === 'never') {
              return false
            } else if (act.enablePolicy === 'perItem') {
              if (!act.hasOwnProperty('ids')) {
                return false
              }
              var ids = act.ids
              for (var i = 0; i < ids.length; i++) {
                if ((act.isInt && parseInt(ids[i]) === parseInt(scope.id)) || (!act.isInt && ids[i] === scope.id)) {
                  return act.active //true
                }
              }
              return false;
            }
            return false
          }

          scope.do_action = function (act, event) {
            act.active = false
            scope.$emit('naction', act, scope.id, event)
          }
        }
      }
    }
  }])

  module.directive('ocActionsleftView', ['$filter', function ($filter) {
    return {
      restrict: 'E',
      templateUrl: 'templates/directives/actionsleft_view.html',
      scope: {
        actions: '=', // need two way (desactivem aqui)
        filter: '=',
        numact: '@', // @ one-way (controler => directive)
        id: '@' // @ one-way (controler => directive), '=' two-way,
      },
      link: {
        pre: function preLink (scope, iElement, iAttrs, controller) {
          scope.getNumAct = function(incre) {
            return parseInt(scope.numact) + incre
          }
          scope.isActive = function (act) {
            if (act.enablePolicy === 'allways') {
              return act.active //true
            } else if (act.enablePolicy === 'never') {
              return false
            } else if (act.enablePolicy === 'perItem') {
              if (!act.hasOwnProperty('ids')) {
                return false
              }
              var ids = act.ids
              for (var i = 0; i < ids.length; i++) {
                if ((act.isInt && parseInt(ids[i]) === parseInt(scope.id)) || (!act.isInt && ids[i] === scope.id)) {
                  return act.active //true
                }
              }
              return false;
            }
            return false
          }

          scope.do_action = function (act, event) {
            act.active = false
            scope.$emit('naction', act, scope.id, event)
          }
        }
      }
    }
  }])

  module.directive('ocActionsView', ['$filter', function ($filter) {
    return {
      restrict: 'E',
      templateUrl: 'templates/directives/actions_view.html',
      scope: {
        actions: '=', // need two way (desactivem aqui)
        filter: '=',
        id: '@' // @ one-way (controler => directive), '=' two-way,
      },
      link: {
        pre: function preLink (scope, iElement, iAttrs, controller) {
          scope.isActive = function (act) {
            if (act.enablePolicy === 'allways') {
              return act.active //true
            } else if (act.enablePolicy === 'never') {
              return false
            } else if (act.enablePolicy === 'perItem') {
              if (!act.hasOwnProperty('ids')) {
                return false
              }
              var ids = act.ids
              for (var i = 0; i < ids.length; i++) {
                if ((act.isInt && parseInt(ids[i]) === parseInt(scope.id)) || (!act.isInt && ids[i] === scope.id)) {
                  return act.active //true
                }
              }
              return false;
            }
            return false
          }

          scope.do_action = function (act, event) {
            act.active = false
            scope.$emit('naction', act, scope.id, event)
          }
        }
      }
    }
  }])

  module.directive('ocAction', ['$filter', function ($filter) {
    return {
      restrict: 'E',
      templateUrl: 'templates/directives/action_view.html',
      scope: {
        actions: '=', // need two way (desactivem aqui)
        actionName: '@', // @ one-way (controler => directive), '=' two-way,
        id: '@' // @ one-way (controler => directive), '=' two-way,
      },
      link: {
        pre: function preLink (scope, iElement, iAttrs, controller) {
          scope.action = function() {
            var acts = $filter('filter')(scope.actions, { id: scope.actionName }, true)
            if (acts.length == 1) {
              //console.log(acts[0]);
              return acts[0]
            }
            //console.log(null);
            return {active:false, name:"", icon:""};
          },
          scope.isActive = function (act) {
            if (act === null || angular.isUndefined(act)) {
                return false
            }
            if (act.enablePolicy === 'allways') {
                return act.active //true
            } else if (act.enablePolicy === 'never') {
                return false
            } else if (act.enablePolicy === 'perItem') {
                if (!act.hasOwnProperty('ids')) {
                    return false
                }
                var ids = act.ids
                for (var i = 0; i < ids.length; i++) {
                    if ((act.isInt && parseInt(ids[i]) === parseInt(scope.id)) || (!act.isInt && ids[i] === scope.id)) {
                        return act.active //true
                    }
                }
                return false;
            }
            return false
          },

          scope.do_action = function (act, event) {
            act.active = false
            scope.$emit('naction', act, scope.id, event)
          }
        }
      }
    }
  }])

return module
})
;
